<template>
	<div id="app">
		<ModalContainer />
		<router-view />
	</div>
</template>

<script setup lang="ts">
import { ModalContainer } from '@voicemod1/voicemod-modal-manager';
</script>

<style lang="scss">
@use '@voicemod1/harmony-tokens/main' as *;

@import 'modern-normalize/modern-normalize.css';

@import '@voicemod1/harmony-fonts/index.css';
@import '@voicemod1/harmony-ui/style.css';

// TODO: remove this once we update to latest tokens
:root {
	--hy-z-index-modal: 150;
}

* {
	font-weight: unset;
	box-sizing: border-box;
	margin: 0;
	padding: 0;
	font-family: var(--hy-font-family-body);
}

html {
	overflow: auto !important;
	font-weight: unset;
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}

#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	width: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background: var(--hy-color-surface-neutral-strong);
	color: var(--hy-color-text-default);

	@media (max-width: 767px) {
		height: auto;
		align-items: initial;
	}
}

a {
	color: var(--hy-color-text-brand);
	text-decoration: none;
	&:visited {
		color: var(--hy-color-text-brand);
	}
	&:hover {
		color: white;
	}
}

h2 {
	color: white;
	font-size: 24px;
	margin-bottom: 20px;
	text-align: center;
}

.xpaystation-widget-lightbox-overlay {
	opacity: 0 !important;
}

.xpaystation-widget-lightbox-content {
	height: 95% !important;
	top: 0px !important;
}
</style>
